
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Execution } from './execution';
import { ExecutionService } from './execution.service';
import { RecordField } from '../record/record';
import { NotifierService, DialogService } from '../ui';
import { DownloadDialogComponent } from './download-dialog.component';

import { each, find, cloneDeep } from 'lodash';

@Component({
  templateUrl: './execution-edit.component.html',
})
export class ExecutionEditComponent implements OnInit {

  execution: Execution
  originalFields: RecordField[]

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private executionService: ExecutionService,
    private notifier: NotifierService,
    private builder: FormBuilder,
    private dialogService: DialogService,
  ) { }

  initForm(execution: Execution) {
    // Init fields models
    each(execution.fields_model, fieldModel => {
      let field = find(execution.fields, f => f.name === fieldModel.text);

      if(!field) {
        field = new RecordField({
          name: fieldModel.text,
          value: ''
        });

        execution.fields.push(field);
      }

      field.model = fieldModel;
    });

    // Save a copy of the fields
    this.originalFields = cloneDeep(execution.fields);

    this.execution = execution;
  }

  ngOnInit() {
    // Get the execution
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.initForm(data.execution);

      this.notifier.endProgress();
    });
  }

  save() {

    if (!this.execution || !this.execution.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.executionService
      .update(this.execution.id, this.execution).pipe(
      finalize(onComplete))
      .subscribe((execution) => {
        this.initForm(execution);

        this.notifier.success('Exécution enregistrée avec succès');
      });
  }

  cancel() {
    this.execution.fields = cloneDeep(this.originalFields);

    return false;
  }

  get fieldsChanged() {
    let changed = false;

    each(this.execution.fields, (field, index) => {
      if(field.value !== this.originalFields[index].value) {
        changed = true;
      }
    });

    return changed;
  }

  downloadOne(event: any) {
    this.dialogService.show({
      component: DownloadDialogComponent,
      props: {

        execution: this.execution,
        link: event.link,
        document: event.document,

        onClose: () => {
          this.dialogService.hide();
        },
      }
    });
  }

  downloadAll() {
    this.dialogService.show({
      component: DownloadDialogComponent,
      props: {

        execution: this.execution,

        onClose: () => {
          this.dialogService.hide();
        },
      }
    });
  }
}
